import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { SignupForm, VerifyEmail } from "./components";

const App: React.FunctionComponent = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/verify" element={<VerifyEmail />} />
        <Route path="/" element={<SignupForm />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
